import { FC } from 'react';
import { SearchInput } from '@new/common/ui/SearchInput/SearchInput';

interface TutorialsSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export const TutorialsSearchBar: FC<TutorialsSearchBarProps> = ({ value, onChange }) => {
  return <SearchInput value={value} onChange={onChange} placeholder="Search tutorials..." />;
};
